module.exports = __webpack_public_path__ + "img/57_4.99e079e2.png";